function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-1150 -480)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1165.082 480)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M525.992,804.353a.492.492,0,0,1-.348-.84l3.587-3.587-3.587-3.587a.492.492,0,0,1,.7-.7l3.934,3.934a.493.493,0,0,1,0,.7l-3.934,3.934A.49.49,0,0,1,525.992,804.353Z",
  transform: "translate(-525.5 -795.5)"
}))),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1150 483.935)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M497.369,822.582H480.32a.82.82,0,0,1-.82-.82V808.32a.82.82,0,0,1,.82-.82h4.918a.492.492,0,1,1,0,.984h-4.754V821.6H497.2v-7.7a.492.492,0,1,1,.984,0v7.869A.82.82,0,0,1,497.369,822.582Z",
  transform: "translate(-479.5 -807.5)"
}))),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1154.918 483.935)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M494.992,816.09a.492.492,0,0,1-.492-.492,8.075,8.075,0,0,1,8.033-8.1h6.23a.492.492,0,1,1,0,.984h-6.23a7.09,7.09,0,0,0-7.049,7.115A.492.492,0,0,1,494.992,816.09Z",
  transform: "translate(-494.5 -807.5)"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  className: "a",
  width: 20,
  height: 20
});

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      fill: "currentColor",
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgShare, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Share.399c03c2.svg";
export { ForwardRef as ReactComponent };